require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-facebook-dropped-the-ball-on-data-so-how-does-it-affect-marketers.json") })
        }
      }, "path---authors-facebook-dropped-the-ball-on-data-so-how-does-it-affect-marketers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-facebook-dropped-the-ball-on-data-so-how-does-it-affect-marketers!./.cache/json/authors-facebook-dropped-the-ball-on-data-so-how-does-it-affect-marketers.json
// module id = 1278
// module chunks = 231608221292675